module.exports = __webpack_public_path__ + "img/animation_src_2.2b5f477e.webp";